import React from 'react';
import '../styles/Components.scss';
import { Link } from 'react-router-dom';

const categories = [
  { name: 'Процессоры', path: '/components/cpu' },
  { name: 'Материнские платы', path: '/components/motherboards' },
  { name: 'Видеокарты', path: '/components/gpu' },
  { name: 'Оперативная память', path: '/components/ram' },
  { name: 'Накопители', path: '/components/storage' },
  { name: 'Блоки питания', path: '/components/psu' },
  { name: 'Охлаждение', path: '/components/cooling' },
  { name: 'Корпуса', path: '/components/cases' },
];

export default function Components() {
  return (
    <div className="components-page">
      <h1 className="components-title">Комплектующие</h1>
      <div className="components-grid">
        {categories.map((cat, index) => (
          <Link to={cat.path} key={index} className="component-card">
            <div className="card-content">
              <h2>{cat.name}</h2>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}